//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CityGroup',
  props: {
    group: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          city: null,
          constructions: []
        };
      }
    },
    adBanners: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    showOnMap: function showOnMap(construction) {
      this.$emit('show-on-map', construction);
    },
    openConstruction: function openConstruction(construction) {
      window.open(construction.url, '_blank');
    }
  }
};